// Palette
import { darken } from '@mui/material/styles';
import palette from '../palette';

export default {
    variants: [
        {
            props: { variant: 'contained' },
            style: {
                boxShadow: 'none',
                '&.Mui-disabled': {
                    color: palette.background.default,
                },
            },
        },
        {
            props: { variant: 'contained', color: 'primary' },
            style: {
                '&:hover .Mui-label': {
                    color: palette.common.white,
                },
            },
        },
        {
            props: { variant: 'contained', color: 'warning' },
            style: {
                backgroundColor: palette.warning.light,
                color: palette.warning.dark,
                '&:hover': {
                    backgroundColor: darken(palette.warning.light, 0.1),
                    color: darken(palette.warning.dark, 0.1),
                },
            },
        },
        {
            props: { variant: 'outlined', color: 'warning' },
            style: {
                color: palette.warning.dark,
                borderColor: palette.warning.dark,
                '&:hover': {
                    borderColor: darken(palette.warning.dark, 0.1),
                    color: darken(palette.warning.dark, 0.1),
                },
            },
        },
        {
            props: { variant: 'text', color: 'warning' },
            style: {
                color: palette.warning.dark,
                '&:hover': {
                    color: darken(palette.warning.dark, 0.1),
                },
            },
        },
    ],
    styleOverrides: {
        root: {
            fontWeight: 'bold',
            textTransform: 'none',
            transitionProperty: 'background-color, border, box-shadow, color',
            '&.Mui-disabled': {
                pointerEvents: 'auto',
            },
        },
    },
};
